import { makeRequest } from "$utils/utils";
import { get, post } from "./api";
import constants from "$utils/constants";

const getToken = async (email: string, password: string) => {
  const response = await get(constants.API.ENDPOINTS.LOGIN, {
    params: { email, password },
  });

  return response;
};

const getRefreshToken = async () => {
  try {
    const refresh_token = localStorage.getItem("refresh_token");
    if (!refresh_token) throw new Error();
    const res = await makeRequest(
      constants.API.ENDPOINTS.REFRESH_TOKEN,
      "POST",
      { refresh_token }
    );
    if (!res?.data) throw new Error();
    return res.data;
  } catch {
    return null;
  }
};

const revokeRefreshToken = async () => {
  try {
    const refresh_token = localStorage.getItem("refresh_token");
    if (refresh_token) {
      await makeRequest(constants.API.ENDPOINTS.REVOKE, "POST", {
        refresh_token,
      });
    }
  } catch {
    //
  }
};

const resetPassord = async (email: string) => {
  const response = await get(constants.API.ENDPOINTS.RESET, {
    params: { email },
  });

  return response;
};

const getUserInfo = async (token: string) => {
  const response = await get(constants.API.ENDPOINTS.USERINFO, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return response;
};

const changePassword = async (userId: string, password: string) => {
  const response = await post(
    `${constants.API.ENDPOINTS.USER.UPDATE}/${userId}`,
    { password }
  );
  return response;
};

const changePasswordOnSetting = async (
  userId: string,
  email: string,
  currentPassword: string,
  newPassword: string
) => {
  const token = localStorage.getItem("access_token");
  const response = await post(
    `${constants.API.ENDPOINTS.USER.CHANGE_SETTING}/${userId}`,
    { email, currentPassword, newPassword },
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response;
};

const verifyPassword = async (
  userId: string,
  email: string,
  password: string
) => {
  try {
    const token = localStorage.getItem("access_token");
    await post(
      `${constants.API.ENDPOINTS.USER.VERIFY_SETTING}/${userId}`,
      {
        email,
        password,
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );
    return true;
  } catch {
    return false;
  }
};

export default {
  getToken,
  resetPassord,
  getUserInfo,
  changePassword,
  changePasswordOnSetting,
  verifyPassword,
  getRefreshToken,
  revokeRefreshToken,
};
